/** Retry delays for hash targets that mount after route/data load. */
export const SCROLL_RETRY_DELAYS_MS = [0, 50, 150, 350, 700, 1200, 2000];

/** Fixed header height + breathing room so section titles aren't hidden. */
export function getScrollOffset() {
  if (typeof window === 'undefined') return 96;
  return window.matchMedia('(min-width: 1024px)').matches ? 96 : 88;
}

/** Scroll to a section id; returns false when the element is not in the DOM yet. */
export function scrollToSection(id, behavior = 'smooth') {
  if (!id) return false;
  const el = document.getElementById(id);
  if (!el) return false;

  const top = el.getBoundingClientRect().top + window.scrollY - getScrollOffset();
  window.scrollTo({ top: Math.max(0, top), behavior });
  return true;
}

/** Keep trying until lazy/async sections have mounted. Returns a cleanup function. */
export function scrollToSectionWithRetry(
  id,
  { behavior = 'auto', delays = SCROLL_RETRY_DELAYS_MS } = {},
) {
  if (!id) return () => {};

  let cancelled = false;
  const timers = delays.map((ms) =>
    window.setTimeout(() => {
      if (!cancelled) scrollToSection(id, behavior);
    }, ms),
  );

  return () => {
    cancelled = true;
    timers.forEach(clearTimeout);
  };
}
